export enum AutoQaSpotlightType {
  DeadAir = 'deadair',
  RecordingDisclosure = 'recording_disclosure',
  ChurnRisk = 'churn_risk',
  ExtraMile = 'extra_mile',
  Sentiment = 'sentiment',
  Outlier = 'outlier',
  FollowUp = 'follow_up',
  EscalationRequest = 'escalation_request',
  SLA = 'sla',
  BotRepetition = 'bot_repetition',
  BotCommunicationEfficiency = 'bot_communication_efficiency',
}
